type Partner = {
  name: string;
  logo: string;
  colorizeBrandOnlyOnHover?: boolean;
};
const partners: Partner[] = [{
  name: 'Auto Centar 7',
  logo: 'https://cdn.magicpatterns.com/uploads/1fqM9kKbe2hFhrra1ojcUq/2.png'
}, {
  name: 'AKSIL Transport',
  logo: 'https://cdn.magicpatterns.com/uploads/nkavUSQ7QgmKpmo7RtoHGF/AKSIL.png'
}, {
  name: 'Forza Properties',
  logo: 'https://cdn.magicpatterns.com/uploads/9DuJDoXqE3yscoFZMSV47t/1.png',
  colorizeBrandOnlyOnHover: true
}, {
  name: 'Optika Lučić',
  logo: 'https://cdn.magicpatterns.com/uploads/oDp4YLLs6PRiVX4c2Ewa3f/3.png'
}, {
  name: 'Radovanović Selidbe',
  logo: 'https://cdn.magicpatterns.com/uploads/c7dhTLqhUx3tprqE6qxhC8/Untitled_design.png'
}];
export function References() {
  return <section className="bg-dark-bg py-4 md:py-5" aria-label="Reference" data-id="element-294" data-mp="155ls93f56maa">
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8" data-id="element-295" data-mp="157y8nc594ol8">
        <ul className="grid grid-cols-2 items-center gap-x-2 gap-y-4 sm:grid-cols-3 sm:gap-x-4 lg:grid-cols-5 lg:gap-x-6" data-id="element-296" data-mp="1082f66u6kfjx">
          {partners.map(partner => <li key={partner.name} className="flex min-w-0 items-center justify-center" data-id="element-297" data-mp="2cslffg9ne5h4">
              <span className="group inline-flex items-center justify-center px-2 py-1.5 transition-transform duration-300 hover:scale-105" data-id="element-298" data-mp="2hry4m7nzromv">
                <span className="relative inline-block" data-id="element-299" data-mp="2mjg4sti6xl6s">
                  <img src={partner.logo} alt={partner.name} loading="lazy" className={`h-16 w-auto max-w-[42vw] object-contain brightness-0 invert opacity-75 transition-all duration-300 group-hover:opacity-100 sm:h-20 sm:max-w-none md:h-24 ${partner.colorizeBrandOnlyOnHover ? '' : 'group-hover:brightness-100 group-hover:invert-0'}`} data-id="element-300" data-mp="2qk9pzf490lvz" />
                  {partner.colorizeBrandOnlyOnHover && <img src={partner.logo} alt="" aria-hidden="true" className="pointer-events-none absolute inset-0 h-full w-full object-contain opacity-0 [clip-path:inset(0_60%_0_0)] transition-opacity duration-300 group-hover:opacity-100" data-id="element-301" data-mp="1b5cafm7oxv17" />}
                </span>
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}